<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="cxcCobranzas"></p-toast>
<p-confirmDialog [transitionOptions]="'0ms'" key="cxccobro" title="Confirmar Acción" appendTo="body">
</p-confirmDialog>
<div class="p-grid" style="width: 98%">
    <div class="p-col-12">
        <app-invmaebarra (signal)="manejarSenales($event)" [botonNuevo]="true" [botonGuardar]="botonGuardar"
            [botonBorrar]="botonBorrar" [botonRegresar]="false" [barraBotonesDesplaz]="true"
            [barraBotones3]="true" [barraBotonesAsiCon]="true" [barraBotones5]="true"
            [botonFrmCorreos]="boolformscorreo" [barraCartera]="false" [botonEditDatosCli]="boolformscorreo"
            [botonBuscarPermanente]="true"
            ></app-invmaebarra>
    </div>
</div>
<p-tabView [(activeIndex)]="index" (onChange)="changeTabs()" [style]="{'width':'98%'}">
    <p-tabPanel header="General">
        <p-scrollPanel [style]="{'width':'100%', 'height':'calc(100vh - 270px)'}">
            <div class="contorno" id="contorno">
                <div class="divgrups">
                    <div class="p-grid">
                        <!--LINEA 1-->
                        <div class="p-col-1">
                            <span>Cliente:</span>
                        </div>
                        <div class="p-col-3">
                            <label for="lblcliente"></label>
                            <input class="frm" id="lblcliente" type="text" pInputText disabled [(ngModel)]="lblcliente"
                                style="color: blue; font-weight: bold;" autocomplete="off">
                        </div>
                        <div class="p-col-1">
                            <span>Teléfonos:</span>
                        </div>
                        <div class="p-col-2">
                            <label for="lbltelefono"></label>
                            <input class="frm" id="lbltelefono" type="text" pInputText disabled
                                [(ngModel)]="lbltelefono" style="color: blue; font-weight: bold;"
                                autocomplete="off">
                        </div>
                       
                        <div class="p-col-1">
                            <span>Ordenar:</span>
                        </div>
                        <div class="p-col-3">
                                <p-dropdown [options]="opcionesOrderBy" [style]="{'width':'100%'}"
                                optionLabel="name" [panelStyle]="{'width':'110%'}"
                                (onChange)="busqorderby($event)"
                                [(ngModel)]="selecttipoorderby"
                                ></p-dropdown>
                                       
                        </div>
                        <div class="p-col-1">
                            <p-checkbox label="Aplicar" binary="true"
                                (click)="aplicarorderby()" [(ngModel)]="chkaplicaorderby" [disabled] = "disabledorderby">
                            </p-checkbox>
                        </div>
                        <!--LINEA 2-->
                        <div class="p-col-12" style="margin-top: -10px">
                            <div class="p-grid">
                                <div class="p-col-1">
                                    <span>Contacto:</span>
                                </div>
                                <div class="p-col-3">
                                    <label for="lblcontacto"></label>
                                    <input class="frm" id="lblcontacto" type="text" pInputText disabled
                                        style="color: blue; font-weight: bold;"
                                        [(ngModel)]="lblcontacto" autocomplete="off">
                                </div>   
                                <div class="p-col-1">
                                    <span>Vendedor:</span>
                                </div>
                                <div class="p-col-2">
                                    <label for="lblvendedor"></label>
                                    <input class="frm" id="lblvendedor" type="text" pInputText disabled
                                        style="color: blue; font-weight: bold;"
                                        [(ngModel)]="lblvendedor" autocomplete="off">
                                </div>
                                <div class="p-col-1">
                                    <span>Correo:</span>
                                </div>
                                <div class="p-col-3">
                                    <label for="lblcorreo"></label>
                                    <input class="frm" id="lblcorreo" type="text" pInputText disabled
                                        style="color: blue; font-weight: bold;"
                                        [(ngModel)]="lblcorreo" autocomplete="off">
                                </div>
                            </div>
                        </div>
                        <!--LINEA 3-->
                        <div class="p-col-12" style="margin-top: -10px">
                            <div class="p-grid">
                                <div class="p-col-1">
                                    <span>Dirección:</span>
                                </div>
                                <div class="p-col-3">
                                    <label for="lbldireccion"></label>
                                    <input class="frm" id="lbldireccion" type="text" pInputText disabled
                                        style="color: blue; font-weight: bold;"
                                        [(ngModel)]="lbldireccion" autocomplete="off">
                                </div>

                                <div class="p-col-1">
                                    <span>Observacion:</span>
                                </div>
                                <div class="p-col-5">
                                    <label for="lblobservacion"></label>
                                    <input class="frm" id="lblobservacion" type="text" pInputText disabled
                                        style="color: blue; font-weight: bold;"
                                        [(ngModel)]="lblobservacion" autocomplete="off">
                                </div>
                                <!-- <div class="p-col-1">
                                    <span>Saldo:</span>
                                </div>
                                <div class="p-col-1">
                                    <label for="lblsaldo"></label>
                                    <input class="frm" id="lblsaldo" type="text" pInputText disabled
                                        style="text-align: right; color: blue; font-weight: bold;" [(ngModel)]="lblsaldo"
                                        autocomplete="off">
                                </div> -->
                            </div>
                        </div>
                        <!--LINEA 4-->
                        <div class="p-col-12" style="margin-top: -15px; margin-bottom: -15px">
                            <div class="p-grid">
                                <div class="p-col-1">
                                    <span>Saldo del Cliente:</span>
                                </div>
                                <div class="p-col-1">
                                    <label for="lblsaldoCli"></label>
                                    <input class="frm" id="lblsaldoCli" type="text" pInputText disabled
                                        style="text-align: right; color: blue; font-weight: bold;" [(ngModel)]="lblsaldoCli"
                                        autocomplete="off">
                                </div>

                                <div class="p-col-1">
                                    <span>Saldo de Cartera:</span>
                                </div>
                                <div class="p-col-1">
                                    <label for="lblsaldo"></label>
                                    <input class="frm" id="lblsaldo" type="text" pInputText disabled
                                        style="text-align: right; color: blue; font-weight: bold;" [(ngModel)]="lblsaldo"
                                        autocomplete="off">
                                </div>
                                <div class="p-col-1">
                                    <span>Seleccionar Todos:</span>
                                </div>
                                <div class="p-col-1">
                                    <label for="lblsaldo"></label>
                                    <p-checkbox value="valSelect" (onChange)="seleccionarall($event)"></p-checkbox>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <app-aggridsaci 
            [width]=""
            [height]="largo" 
            [enableSorting]="false" 
            [enableFilter]="true"
            [rowData]="cxctrncobranzasService.trncobranza" 
            [frameworkComponents]="frameworkComponents"
            [animateRows]="true" 
            [rowSelection]="rowSelection" 
            [columnDefs]="columnDefsCxcTrnCob"
            [defaultColDef]="defaultCxcTrnCob" 
            [rowStyle]="rowStyle" 
            [singleClickEdit]="false" 
            [botones]="false"
            [mostrarGuardar]="false" 
            [botonesAdicionales]="false" 
            [comboOpciones]=""
            (selected)="seleccionItem($event)" 
            [tipodetalle]="">
            </app-aggridsaci>
        </p-scrollPanel>
    </p-tabPanel>
  <p-tabPanel header="Estado de Cuenta" [disabled]="diasabledtabs">
		<div class="divgrups">
			<div class="p-grid">
				<div class="p-col-2">
					<span>Cliente:</span>
				</div>
				<div class="p-col-6">
					<span>{{lblclicodigo + ' - ' + lblcliente}}</span>
				</div>
				<div class="p-col-2">
				</div>
				 <!-- <div class="p-col-2">
					<button class="medium" style="background-image: url(../../assets/images/iconos/024-message.webp)"
						(click)="enviarEstadoCuenta()">
					</button>
				</div>  -->
			</div>
		</div>
		<app-aggridsaci [width]="" [height]="largoestcta" [enableSorting]="true" [enableFilter]="true"
			[rowData]="cxctmptrnresumen" [frameworkComponents]="frameworkComponents" [animateRows]="true"
			[rowSelection]="rowSelection" [columnDefs]="columnDefsCxctmptrnresumen"
			[defaultColDef]="defaultColDefCxctmptrnresumen" [rowStyle]="rowStyleEC" [botones]="false"
			[singleClickEdit]="false"></app-aggridsaci>
    </p-tabPanel>
    
	<p-tabPanel header="Saldos" [disabled]="diasabledtabs">
		<div class="divgrups">
			<div class="p-grid">
				<div class="p-col-2">
					<span>Cliente:</span>
				</div>
				<div class="p-col-6">
					<span >{{lblclicodigo + ' - ' + lblcliente}}</span>
				</div>
				<div class="p-col-4">
				</div>
			</div>
		</div>
		<app-aggridsaci [width]="" [height]="largoestcta" [enableSorting]="true" [enableFilter]="true"
			[rowData]="cxctrnresumen" [frameworkComponents]="frameworkComponents" [animateRows]="true"
			[rowSelection]="rowSelection" [columnDefs]="columnDefsCxctrnresumen"
			[defaultColDef]="defaultColDefCxctrnresumen" [rowStyle]="rowStyleSaldo" [botones]="false"
			[singleClickEdit]="false"></app-aggridsaci>
    </p-tabPanel> 
    
    <p-tabPanel header="Resumen" [disabled]="diasabledtabsR">
        <div class="contorno" id="contorno2">
            <div class="divgrups">
                <div class="p-grid">
                    <!--LINEA 1-->
                    <div class="p-col-1">
                        <span>Cliente:</span>
                    </div>
                    <div class="p-col-3">
                        <label for="lblcliente"></label>
                        <input class="frm" id="lblcliente" type="text" pInputText disabled [(ngModel)]="lblcliente"
                            style="color: blue; font-weight: bold;" autocomplete="off">
                    </div>
                    <div class="p-col-1">
                        <span>Teléfonos:</span>
                    </div>
                    <div class="p-col-2">
                        <label for="lbltelefono"></label>
                        <input class="frm" id="lbltelefono" type="text" pInputText disabled
                            [(ngModel)]="lbltelefono" style="color: blue; font-weight: bold;"
                            autocomplete="off">
                    </div>
                   
                    <div class="p-col-1">
                        <span>Ordenar:</span>
                    </div>
                    <div class="p-col-3">
                            <p-dropdown [options]="opcionesOrderBy" [style]="{'width':'100%'}"
                            optionLabel="name" [panelStyle]="{'width':'110%'}"
                            (onChange)="busqorderby($event)"
                            [(ngModel)]="selecttipoorderby"
                            [disabled] = "true"
                            ></p-dropdown>
                                   
                    </div>
                    <div class="p-col-1">
                        <p-checkbox label="Aplicar" binary="true"
                            (click)="aplicarorderby()" [(ngModel)]="chkaplicaorderby" [disabled] = "true">
                        </p-checkbox>
                    </div>
                    <!--LINEA 2-->
                    <div class="p-col-12" style="margin-top: -10px">
                        <div class="p-grid">
                            <div class="p-col-1">
                                <span>Contacto:</span>
                            </div>
                            <div class="p-col-3">
                                <label for="lblcontacto"></label>
                                <input class="frm" id="lblcontacto" type="text" pInputText disabled
                                    style="color: blue; font-weight: bold;"
                                    [(ngModel)]="lblcontacto" autocomplete="off">
                            </div>   
                            <div class="p-col-1">
                                <span>Vendedor:</span>
                            </div>
                            <div class="p-col-2">
                                <label for="lblvendedor"></label>
                                <input class="frm" id="lblvendedor" type="text" pInputText disabled
                                    style="color: blue; font-weight: bold;"
                                    [(ngModel)]="lblvendedor" autocomplete="off">
                            </div>
                            <div class="p-col-1">
                                <span>Correo:</span>
                            </div>
                            <div class="p-col-3">
                                <label for="lblcorreo"></label>
                                <input class="frm" id="lblcorreo" type="text" pInputText disabled
                                    style="color: blue; font-weight: bold;"
                                    [(ngModel)]="lblcorreo" autocomplete="off">
                            </div>
                        </div>
                    </div>
                     <!--LINEA 3-->
                     <div class="p-col-12" style="margin-top: -10px">
                        <div class="p-grid">
                            <div class="p-col-1">
                                <span>Dirección:</span>
                            </div>
                            <div class="p-col-3">
                                <label for="lbldireccion"></label>
                                <input class="frm" id="lbldireccion" type="text" pInputText disabled
                                    style="color: blue; font-weight: bold;"
                                    [(ngModel)]="lbldireccion" autocomplete="off">
                            </div>
    
                            <div class="p-col-1">
                                <span>Observacion:</span>
                            </div>
                            <div class="p-col-5">
                                <label for="lblobservacion"></label>
                                <input class="frm" id="lblobservacion" type="text" pInputText disabled
                                    style="color: blue; font-weight: bold;"
                                    [(ngModel)]="lblobservacion" autocomplete="off">
                            </div>
                            <!-- <div class="p-col-1">
                                <span>Saldo:</span>
                            </div>
                            <div class="p-col-1">
                                <label for="lblsaldo"></label>
                                <input class="frm" id="lblsaldo" type="text" pInputText disabled
                                    style="text-align: right; color: blue; font-weight: bold;" [(ngModel)]="lblsaldo"
                                    autocomplete="off">
                            </div> -->
                        </div>
                    </div>
                    <!--LINEA 4-->
                    <div class="p-col-12" style="margin-top: -15px; margin-bottom: -15px">
                        <div class="p-grid">
                            <div class="p-col-1">
                                <span>Saldo del Cliente:</span>
                            </div>
                            <div class="p-col-1">
                                <label for="lblsaldoCli"></label>
                                <input class="frm" id="lblsaldoCli" type="text" pInputText disabled
                                    style="text-align: right; color: blue; font-weight: bold;" [(ngModel)]="lblsaldoCli"
                                    autocomplete="off">
                            </div>
    
                            <div class="p-col-1">
                                <span>Saldo de Cartera:</span>
                            </div>
                            <div class="p-col-1">
                                <label for="lblsaldo"></label>
                                <input class="frm" id="lblsaldo" type="text" pInputText disabled
                                    style="text-align: right; color: blue; font-weight: bold;" [(ngModel)]="lblsaldo"
                                    autocomplete="off">
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <app-aggridsaci 
        [width]="" 
        [height]="largoestcta"
        [enableSorting]="true" 
        [enableFilter]="true"
        [rowData]="cxctrncobranzasService.cxctrcobnresumen"
        [frameworkComponents]="frameworkComponents" 
        [animateRows]="true"
        [rowSelection]="rowSelection" 
        [columnDefs]="columnDefsCxcCobtrnresumen"
        [defaultColDef]="defaultColDefCxcCobtrnresumen" 
        [rowStyle]="rowStyle" 
        [botones]="false"
        [singleClickEdit]="false"
        (selected)="seleccionItemCob($event)" ></app-aggridsaci>
    </p-tabPanel> 
    <p-tabPanel header="Comprobantes" [disabled]="diasabledtabs">
        <div class="divgrups">
            <div class="p-grid">
                <!--LINEA 1-->
                <!-- <div class="p-col-1">
                    <span>Número:</span>
                </div>
                <div class="p-col-1">
                    <label for="ENCREGCOMPRO_NUMERO"></label>
                    <input class="frm" id="ENCREGCOMPRO_NUMERO" type="text" pInputText disabled [(ngModel)]="cxcregcomprobanteService.encregcomp[indicador].ENCREGCOMPRO_NUMERO"
                        style="color: blue; font-weight: bold;" autocomplete="off">
                </div> -->
                <div class="p-col-1">
                    <span>Banco:</span>
                </div>
                <div class="p-col-2">
                    <label for="BAN_CODIGO"></label>
                    <input class="frm" id="BAN_CODIGO" type="text" pInputText [disabled]="false"
                        [(ngModel)]="BAN_CODIGO"
                        (keydown.enter)="setFocus($event)" 
                        autocomplete="off">
                </div>
                <div class="p-col-1">
                    <button type="button"
                        style="background-image: url(../../../assets/images/iconos/buscar.webp);"
                        (click)="busquedabanco(BAN_CODIGO)"></button>
                </div>
                <div class="p-col-3">
                    <label for="lblbannombre"></label>
                    <input class="frm" id="lblbannombre" type="text" pInputText disabled
                        style="color: blue;"
                        [(ngModel)]="lblbannombre"
                        autocomplete="off">
                </div>
                <div class="p-col-1">
                    <button (click)="aceptar()" pButton class="aceptar"
                            style="line-height: 2.5em; font-family: Arial, serif; margin-top: -5px; height: 30px; width: 100px; ">
                        Aceptar
                    </button>
                </div>
                <!--LINEA 2-->
                <!-- <div class="p-col-12" style="margin-top: -10px">
                    <div class="p-grid">
                        <div class="p-col-1">
                            <span>Fecha:</span>
                        </div>
                        <div class="p-col-1">
                            <p-calendar id="ENCREGCOMPRO_FECHA"
                                [inputStyle]="{width: '100%', height: '20px'}"
                                [(ngModel)]="cxcregcomprobanteService.encregcomp[indicador].ENCREGCOMPRO_FECHA"
                                [readonlyInput]="false" dateFormat="dd/mm/yy" (keydown.enter)="setFocus($event)"
                                (keydown)="botonesmodificar()">
                            </p-calendar>
                        </div>
                        <div class="p-col-1">
                            <span>Concepto:</span>
                        </div>
                        <div class="p-col-5">
                            <label for="ENCREGCOMPRO_CONCEPTO"></label>
                            <input class="frm" id="ENCREGCOMPRO_CONCEPTO" type="text" pInputText
                                [(ngModel)]="cxcregcomprobanteService.encregcomp[indicador].ENCREGCOMPRO_CONCEPTO"
                                (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
                                autocomplete="off">
                        </div>
                    </div>
                </div> -->
               
            </div>
        </div>
        <p-scrollPanel [style]="{'width':'100%', 'height':'calc(100vh - 270px)'}">
            
            <app-aggridsaci 
            [width]=""
            [height]="70" 
            [enableSorting]="true" 
            [enableFilter]="true"
            [rowData]="cxcdetcomprobanteService.detregcomp" 
            [frameworkComponents]="frameworkComponents"
            [animateRows]="true" 
            [rowSelection]="rowSelection" 
            [columnDefs]="columnDefsDetcomprobante"
            [defaultColDef]="defaultCxcdetcomp" 
            [rowStyle]="rowStyle" 
            [singleClickEdit]="false" 
            [botones]="true"
            [mostrarGuardar]="false" 
            [botonesAdicionales]="false" 
            [comboOpciones]=""
            [solobotoneliminar]="true"
            (selected)="seleccionItemcomp($event)" 
            [tipodetalle]=""
            (cambios)="cambio($event)"
            [CC]="true">
            </app-aggridsaci>
            <!-- <div class="divgrups" style="margin-top: 10px;">
                <div class="p-grid" style="margin-bottom: -10px;">
                    <div class="p-col-4">
                        <span>Comprobantes ya registrados en bancos o en registro de comprobantes</span>
                    </div>
                    <div class="p-col-1" style="margin-top: 10px; height: 25%; background-color: rgb(245,236,166)">
                    </div>
                </div>
            </div> -->
        </p-scrollPanel>
    </p-tabPanel>
</p-tabView>

<p-dialog header="Historial" [(visible)]="displayDialogCxcTrnHis" [transitionOptions]="'0ms'" [modal]="true"
    appendTo="body" [style]="{width:'80vw', height:'120vh'}" [closable]="false" [draggable]="false">
    <app-cxctrnedithist *ngIf="displayDialogCxcTrnHis" [strnumfac]="trncobro" [clicodigo]="clicodigo"
        [secuencial]="secuncial" (signalSalir)="recibirSenalesCxcEdithis($event)"></app-cxctrnedithist>
</p-dialog>

<div style="position: fixed;
			z-index: 999;
			height: 2em;
			width: 2em;
			overflow: visible;
			margin: auto;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;">
    <p-progressSpinner *ngIf="spin" [style]="{width: '100px', height: '100px'}" animationDuration=".5s">
    </p-progressSpinner>
    <!-- <p-dialog [(visible)]="spin" [transitionOptions]="'0ms'" [modal]="true"  [closable]="false"
	[style]="{ opacity: 0.00}" position="top">
	</p-dialog> -->
</div>
<!-- CDPJ -->
<p-dialog header="Formularios de Correos" [(visible)]="displayDialogfrmcorreos" [transitionOptions]="'0ms'" [modal]="true"
	appendTo="body" [style]="{width: '40vw', height: '400px'}">
	<app-sacifrmenviocorreos [auxiliar]="auxreporte" [strNombreForma]="strNombreForma"
		[strNumDoc]="detallecobSelected.CLI_CODIGO"
		[strCampo]="'CLI_CODIGO'"
		[strNumDoc2]=""
		[strCampo2]="''" 
		[strCliProvCod]="detallecobSelected.CLI_CODIGO"
		(cerrar)="cerrarfrmcorreos()"></app-sacifrmenviocorreos>
</p-dialog>
<p-dialog *ngIf="displayDialogeditdatoscli === true" header="Actualizar Datos del Cliente" [(visible)]="displayDialogeditdatoscli" [transitionOptions]="'0ms'" [modal]="true"
	appendTo="body" [style]="{width: '70vw', height: '70vh'}" >
    <app-cxceditdatoscliente 
    [stCliCodigo]="detallecobSelected.CLI_CODIGO"
	
	(salir)="cerrareditdatoscli()">
	</app-cxceditdatoscliente>
</p-dialog>
<p-dialog *ngIf="displayDialofencfac === true" header="Facturas de Ventas" [(visible)]="displayDialofencfac" [transitionOptions]="'0ms'" [modal]="true"
	appendTo="body" [style]="{width: '90vw', height: '90vh'}" >
    <app-cxcconsulfacven 
    [stnumfac]="detalleSelected.TRNCOBRO_NRODOC"
	(salir)="cerrarencfac()">
	</app-cxcconsulfacven>
</p-dialog>
<p-dialog header="Busqueda de Datos" [(visible)]="displayDialogBusquedaFast"
		  [transitionOptions]="'0ms'"
		  [modal]="true"
		  appendTo="body"
		  [style]="{width: '70vw', height: '70vh'} ">
	<app-busquedadlgmae [arrayOptions]="types" [arregloConsulta]="arregloCons" [consulta]="consulta" [tabla]="tabla"
						[where]="condicion"
						[busquedaParams]="busquedacampos"
						(opcionSeleccionada)="manejarSeleccion($event)"
						[busquedaCompuesta]="false"></app-busquedadlgmae>
</p-dialog>

<p-dialog header="Busqueda de Datos" [(visible)]="displayDialogBusqueda"
		  [transitionOptions]="'0ms'"
		  [modal]="true"
		  appendTo="body"
		  [style]="{width: '70vw', height: '70vh'} ">
	<app-busquedadlg [arrayOptions]="types" [arregloConsulta]="arregloCons" [consulta]="consulta" [tabla]="tabla"
					 [where]="where"
					 [busquedaParams]="busquedacampos"
					 (opcionSeleccionada)="manejarSeleccion($event)"></app-busquedadlg>
</p-dialog>
<!-- CDPJ -->